import classnames from 'classnames/bind';
import { FC, ReactNode } from 'react';
import styles from './PayeeInfo.module.scss';

const cx = classnames.bind(styles);

type Props = {
  label: string;
  value: ReactNode;
  valueClassName?: string;
};

export const PayeeInfoRow: FC<Props> = ({ label, value, valueClassName }) => {
  return (
    <div className={cx(styles['payee-info-row'])}>
      <span className={cx(styles['payee-info-label'])}>{label}</span>
      <span className={cx(styles['payee-info-value'], valueClassName)}>
        {value}
      </span>
    </div>
  );
};

PayeeInfoRow.displayName = 'PayeeInfoRow';
